import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMarketExprtGeneralPanel extends Layout {
    greenscreensGeneralPanel: Panel;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    labelGreenscreen: Label;
    mpactGeneralPanel: Panel;
    panel2: Panel;
    panel4: Panel;
    sourceMarketrateExprt: DataSource;
    switchActive: Switch;
    switchGreenscreensActive: Switch;
    textbox10: Textbox;
    textbox12: Textbox;
    textbox13: Textbox;
    textbox9: Textbox;
    textboxMpactCompanyType: Textbox;
}
